/**
 * @file  重庆琴缘
 * @create lixiang 2025/05/12
 * @update
 */
import React, { useState } from "react";
import bg from "../../../assets/images/yzqf/cqqybg.jpg";
import timeline from "../../../assets/images/yzqf/glp/timeline.png";
import { glpdata } from "./data";
import Glpitem from "./Glpitem";
function CQQY({ setType }) {
  const pagecount = 3;
  const [page, setPage] = useState(0);
  return (
    <div className="common-page animate__animated animate__fadeIn">
      <img src={bg} alt="" />
      <div className="cqqyitembox">
        {page === 0 &&
          glpdata.cqqy.slice(0, 3).map((item, index) => {
            return <Glpitem item={item} index={index} key={index} />;
          })}
        {page === 1 &&
          glpdata.cqqy.slice(3, 6).map((item, index) => {
            return <Glpitem item={item} index={index} key={index} />;
          })}
        {page === 2 && (
          <div className="lastimg animate__animated animate__fadeIn">
            <img src={timeline} alt="" />
          </div>
        )}
      </div>
      <div className="pagebox">
        <div
          className="l"
          onClick={() =>
            setPage(page - 1 < 0 ? pagecount - 1 : page - 1)
          }></div>
        <div
          className="r"
          onClick={() => setPage(page + 1 >= pagecount ? 0 : page + 1)}></div>
      </div>
      <div
        className="back"
        onClick={() => {
          setType("");
        }}></div>
    </div>
  );
}

export default CQQY;
